import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { FaWhatsapp } from "react-icons/fa";

function LoginPage({ auth }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const menuUrl     = "https://www.nuovoforno1966.it/menu";
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`Ciao! Qui trovi il nostro menu: ${menuUrl} ⭐  Votaci, il tuo voto conta! ❤️`)}`;

  const handleLogin = () => {
    signInWithEmailAndPassword(auth, username, password)
      .then((userCredential) => {
        const user = userCredential.user;
        navigate("/client", { state: { username: user.email } });
      })
      .catch(() => {
        setErrorMessage("Invalid username or password");
      });
  };

  return (
    <div className="flex flex-col min-h-screen">

      <div className="flex flex-grow items-center justify-center px-4 sm:px-6 lg:px-8 py-10">
        <div className="w-full max-w-lg space-y-8">
          <div>
            <img
              className="mx-auto h-20 w-auto sm:h-32"
              src="/img/logoTrasparente.png"
              alt="Logo Matteo"
            />
            <h2 className="mt-6 text-center text-2xl sm:text-3xl font-bold tracking-tight text-gray-900">
              Nuovo Forno dal 1966
            </h2>
            {errorMessage && (
              <p className="mt-2 text-center text-sm text-red-600">
                {errorMessage}
              </p>
            )}
          </div>
          <form className="mt-8 space-y-6">
            <div className="rounded-md shadow-sm space-y-4">
              <div>
                <label htmlFor="username" className="sr-only">
                  Username
                </label>
                <input
                  id="username"
                  name="username"
                  type="text"
                  autoComplete="off"
                  required
                  className="block w-full rounded-md border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  className="block w-full rounded-md border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>

            <div>
              <button
                type="button"
                onClick={handleLogin}
                className="flex w-full justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                Login
              </button>
            </div>
          </form>

          <p className="mt-2 text-center text-sm text-gray-600">
            Don't have an account?{" "}
            <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
              Sign up
            </a>
          </p>

          {/* ── Menu & Condividi ── */}
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
            paddingTop: 8,
          }}>
            <a
              href={menuUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                width: 40, height: 40, borderRadius: 12,
                display: "flex", alignItems: "center", justifyContent: "center",
                textDecoration: "none",
                background: "#fef3c7",
                border: "1.5px solid #f59e0b",
                transition: "background 0.2s, transform 0.15s",
              }}
              title="Visualizza menu"
              onMouseEnter={e => { e.currentTarget.style.background = "#fde68a"; e.currentTarget.style.transform = "translateY(-2px)"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "#fef3c7"; e.currentTarget.style.transform = "translateY(0)"; }}
            >
              <span style={{ fontSize: 11, fontWeight: 700, color: "#b45309" }}>MENU</span>
            </a>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                width: 40, height: 40, borderRadius: 12,
                display: "flex", alignItems: "center", justifyContent: "center",
                textDecoration: "none",
                background: "#dcfce7",
                border: "1.5px solid #22c55e",
                transition: "background 0.2s, transform 0.15s",
              }}
              title="Condividi menu su WhatsApp"
              onMouseEnter={e => { e.currentTarget.style.background = "#bbf7d0"; e.currentTarget.style.transform = "translateY(-2px)"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "#dcfce7"; e.currentTarget.style.transform = "translateY(0)"; }}
            >
              <FaWhatsapp size={18} style={{ color: "#16a34a" }} />
            </a>
          </div>

        </div>
      </div>

    </div>
  );
}

export default LoginPage;